module.exports = __webpack_public_path__ + "tv.050048b21adf547c1fe5.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/tv.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/tv.svg
// module chunks = styles